export default function getInitState() {
    return {
        actions: [
            // {
            //     btn_text: '<i class="fas fa-filter"></i> Szűrés',
            //     event_name: "customClick",
            //     class: "btn btn-primary my-custom-class",
            //     event_payload: 'showSearchModal'
            // }
        ],
        dataTableOptions: {
            server_mode: true,
            per_page: 10,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        searchFields: [
            {
                name: "nev",
                label: "Terméknév",
                formSize: 3,
                formType: 'text',
                formVisible: true
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                formSize: 3,
                formType: 'text',
                formVisible: true,
            },
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                class: "btn btn-outline-success",
                event_payload: 'selectRow'
            }
        ],
        headerFields: [
            {
                name: "ttt",
                label: "TTT kód",
                sort: false,
                visibility: true,
                slot_name: 'formatGYSE',
                filter: {
                    type: "simple",
                }
            },
            {
                name: "nev",
                label: "Gyógyszer",
                sort: false,
                visibility: true,
                filter: {
                    type: "simple",
                    debounceRate: 500,
                }
                //slot_name: "gyogyszerSzinezesForgalomban"
            },
            {
                name: "atc",
                label: "ATC kód",
                sort: false,
                visibility: true,
                slot_name: "rowSelect",
                filter: {
                    type: "simple",
                }
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                sort: false,
                visibility: true,
                filter: {
                    type: "simple",
                }
            },
            {
                name: "kisznev",
                label: "Kiszerelés",
                sort: false,
                visibility: true,
            },
            {
                name: "tamalap.fab",
                label: "Alapár",
                sort: false,
                visibility: true,
                slot_name: "commission_format2"
            },
            {
                name: "tk",
                label: "Nyilvántartási szám",
                sort: false,
                visibility: true,
            },
            {
                name: "ntk",
                label: "NTK",
                visibility: false
            },
            {
                name: "oepInb",
                label: "Norm. tb. tám.",
                visibility: false
            },
            {
                name: "normTerdij",
                label: "Norm. tér.",
                visibility: false
            },
            {
                name: "ntkTd",
                label: "Norm. NTD",
                visibility: false
            },
            {
                name: "id",
                label: "Azonosító",
                visibility: false
            },
            {
                name: "tipus",
                label: "Típus",
                visibility: false
            },
            {
                name: "oepDat",
                label: "Érvényesség kezdete",
                visibility: false
            },
            {
                name: "oepEan",
                label: "EAN kód",
                visibility: false
            },
            {
                name: "adagmod",
                label: "Adagolás módja",
                visibility: false
            },
            {
                name: "idGyforma",
                label: "Gyógyszer forma ID",
                visibility: false
            },
            {
                name: "gyforma",
                label: "Gyógyszerforma",
                visibility: false
            },
            {
                name: "rendelhet",
                label: "Rendelhet",
                visibility: false
            },
            {
                name: "egyenid",
                label: "Egyenértékűségi csoport ID",
                visibility: false
            },
            {
                name: "potencia",
                label: "Potencia",
                visibility: false
            },
            {
                name: "ohatoMenny",
                label: "Összes hatóanyag tartalom",
                visibility: false
            },
            {
                name: "hatoMenny",
                label: "Egy kiszerelési egységben lévő hatóanyag mennyiség",
                visibility: false
            },
            {
                name: "hatoEgys",
                label: "Egy kiszerelési egységben lévő hatóanyag egység",
                visibility: false
            },
            {
                name: "kiszMenny",
                label: "Kiszerelés mennyiség",
                visibility: false
            },
            {
                name: "kiszEgys",
                label: "Kiszerelés egység",
                visibility: false
            },
            {
                name: "dddMenny",
                label: "DDD értéke",
                visibility: false
            },
            {
                name: "dddEgys",
                label: "DDD mennyiség egysége",
                visibility: false
            },
            {
                name: "dddFaktor",
                label: "Hatóanyag egys. és DDD egys. váltószám",
                visibility: false
            },
            {
                name: "dot",
                label: "Kiszerelés hány napra elegendő",
                visibility: false
            },
            {
                name: "adagMenny",
                label: "Kiszerelés hány egységnek megfelelő mennyiség",
                visibility: false
            },
            {
                name: "adagEgys",
                label: "Szokásosan felírt mennyiség egység",
                visibility: false
            },
            {
                name: "oepTar",
                label: "Termelői ár",
                visibility: false
            },
            {
                name: "oepNkar",
                label: "Nagykereskedelmi ár",
                visibility: false
            },
            {
                name: "oepFan",
                label: "Fogyasztói ár (nettó)",
                visibility: false
            },
            {
                name: "oepAfa",
                label: "ÁFA",
                visibility: false
            },
            {
                name: "oepItm",
                label: "Régi támogatásjelzés",
                visibility: false
            },
            {
                name: "oepJc1",
                label: "Honvédelmi jogosultsággal felírható",
                visibility: false
            },
            {
                name: "oepJc2",
                label: "Közgyógy ellátott betegeknek felírható ",
                visibility: false
            },
            {
                name: "oepJc3",
                label: "Üzemi baleset esetén felírható",
                visibility: false
            },
            {
                name: "oepJc4",
                label: "EÜ kiemelt jogosultsággal felírható",
                visibility: false
            },
            {
                name: "oepJc5",
                label: "EÜ emelt jogosultsággal felírható",
                visibility: false
            },
            {
                name: "kgykeret",
                label: "Közgyógy keret meghatározásakor figyelembe vehető?",
                visibility: false
            },
            {
                name: "egysegar",
                label: "Hatóanyag egységára",
                visibility: false
            },
            {
                name: "normTip",
                label: "Támogatásra vonatkozó megjelölés",
                visibility: false
            },
            {
                name: "normSzaz",
                label: "Támogatás mértéke %",
                visibility: false
            },
            {
                name: "normFixid",
                label: "Normatív fixcsoport ID",
                visibility: false
            },
            {
                name: "normRefntk",
                label: "Normatív fixcsoport referencia NTK-ja ",
                visibility: false
            },
            {
                name: "oepInn",
                label: "Normatív támogatás nettó",
                visibility: false
            },
            {
                name: "normMihaid",
                label: "Minőségi és Hatékony Gyógyszerrendelési Ösztönzés - csoportazonosító",
                visibility: false
            },
            {
                name: "normMihacel",
                label: "Minőségi és Hatékony Gyógyszerrendelési Ösztönzés - a gyógyszer csoportjának célértéke",
                visibility: false
            },
            {
                name: "normMihastat",
                label: "Minőségi és Hatékony Gyógyszerrendelési Ösztönzés - a gyógyszer státusza",
                visibility: false
            },
            {
                name: "normKihi",
                label: "Normatív jogcímen a kihordási idő ",
                visibility: false
            },
            {
                name: "normFelme",
                label: "Normatív jogcímen a felírható mennyiség ",
                visibility: false
            },
            {
                name: "euemTip",
                label: "Az EÜ emelt támogatás technikája",
                visibility: false
            },
            {
                name: "euemSzaz",
                label: "Támogatás mértéke %-ban EÜ emelt támogatás esetén",
                visibility: false
            },
            {
                name: "euemFixid",
                label: "EÜ emelt fixcsoport azonosítója",
                visibility: false
            },
            {
                name: "euemRefntk",
                label: "EÜ emelt fixcsoport referencia NTK-ja",
                visibility: false
            },
            {
                name: "oepEun",
                label: "EÜ emelt támogatás nettó",
                visibility: false
            },
            {
                name: "oepEub",
                label: "EÜ emelt támogatás bruttó",
                visibility: false
            },
            {
                name: "euemTerdij",
                label: "A beteg által fizetendő térítési díj (EÜ emelt támogatás esetén)",
                visibility: false
            },
            {
                name: "ntkEetd",
                label: "A beteg által fizetendő térítési díj alapján kiszámított napi terápiás költség (EÜ emelt támogatás esetén)",
                visibility: false
            },
            {
                name: "euemPontok",
                label: "EÜ pontok, amire a termék EÜ emelt támogatással írható",
                visibility: false
            },
            {
                name: "euemKihi",
                label: "EÜ emelt jogcímen a kihordási idő",
                visibility: false
            },
            {
                name: "euemFelme",
                label: "EÜ emelt jogcímen a felírható mennyiség",
                visibility: false
            },
            {
                name: "eukiemTip",
                label: "Az EÜ kiemelt támogatás technikája",
                visibility: false
            },
            {
                name: "eukiemSzaz",
                label: "Támogatás mértéke %-ban EÜ kiemelt támogatás esetén",
                visibility: false
            },
            {
                name: "eukiemFixid",
                label: "EÜ kiemelt fixcsoport azonosítója",
                visibility: false
            },
            {
                name: "eukiemRefntk",
                label: "EÜ kiemelt fixcsoport referencia NTK-ja",
                visibility: false
            },
            {
                name: "oepEu100n",
                label: "EÜ kiemelt támogatás nettó",
                visibility: false
            },
            {
                name: "oepEu100b",
                label: "EÜ kiemelt támogatás bruttó",
                visibility: false
            },
            {
                name: "eukiemTerdij",
                label: "A beteg által fizetendő térítési díj (EÜ kiemelt támogatás esetén)",
                visibility: false
            },
            {
                name: "ntkEktd",
                label: "A beteg által fizetendő térítési díj alapján kiszámított napi terápiás költség (EÜ kiemelt támogatás esetén)",
                visibility: false
            },
            {
                name: "eukiemPontok",
                label: "EÜ pontok, amire a termék EÜ kiemelt támogatással írható",
                visibility: false
            },
            {
                name: "eukiemKihi",
                label: "EÜ kiemelt jogcímen a kihordási idő",
                visibility: false
            },
            {
                name: "eukiemFelme",
                label: "EÜ kiemelt jogcímen a felírható mennyiség",
                visibility: false
            },
            {
                name: "forgalomban",
                label: "Forgalomban?",
                visibility: false
            },
            {
                name: "besorolas",
                label: "A költséghatékonysági kategória kódja jogcímenként ",
                visibility: false
            },
            {
                name: "prasTermek",
                label: "PReferált ÁrSávba tartozó termék",
                visibility: false
            },
            {
                name: "patika",
                label: "Patikában/patikán kívül kapható",
                visibility: false
            }, {
                name: "egyedi",
                label: "Egyedi méretvétel alapján?",
                visibility: false
            },
            {
                name: "oepIso",
                label: "Gyógyászati segédeszköz azonosító ISO kódja",
                visibility: false
            },
            {
                name: "forgengtId",
                label: "Forgalomba hozatali engedély jogosultja/Gyártó ID",
                visibility: false
            },
            {
                name: "keresztjelzes",
                label: "OGYI hatáserősség (méregosztály) jelzése",
                visibility: false
            },
            {
                name: "rendelhetoseg",
                label: "Rendelhetőség",
                visibility: false
            },
            {
                name: "forgengt",
                label: "Forgalomba hozatali engedély jogosultja/Gyártó",
                visibility: false
            },
            {
                name: "forgalmazId",
                label: "Forgalmazó ID",
                visibility: false
            },
            {
                name: "forgalmaz",
                label: "Forgalmazó",
                visibility: false
            },
            {
                name: "brandId",
                label: "A gyógyszer márkanevének azonosítója",
                visibility: false
            },
            {
                name: "brandnev",
                label: "A gyógyszer márkaneve",
                visibility: false
            },
            {
                name: "kestTerm",
                label: "Kedvezményezett státuszú termék?",
                visibility: false
            },
            {
                name: "kozhid",
                label: "OGYI termékazonosító",
                visibility: false
            },
            {
                name: "nicheId",
                label: "nicheId",
                visibility: false
            },
            {
                name: "regiNev",
                label: "Az átnevezett készítmény / eszköz korábbi neve",
                visibility: false
            },
            {
                name: "switch",
                label: "Változás kódja",
                visibility: false
            },
            {
                name: "tktorles",
                label: "A törzskönyvből törölt készítmények megjelölése",
                visibility: false
            },
            {
                name: "tktorlesdat",
                label: "A készítmény törzskönyvi törlésének dátuma",
                visibility: false
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
            }
        ],

        euPontokRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                class: "btn btn-outline-success",
                event_payload: 'selectEuPontRow'
            }
        ],
        euPontokHeaderFields: [
            {
                name: "eupontId",
                label: "EÜ pont ID",
                visibility: false
            },
            {
                name: "euPont",
                label: "EÜ. pont",
                visibility: true
            },
            {
                name: "szakvizsga",
                label: "Szakvizsga",
                visibility: true
            },
            {
                name: "javaslatra",
                label: "Javaslatra",
                visibility: true
            },
            {
                name: "idokorlat",
                label: "Időkorlát (hó)",
                visibility: true
            },
            {
                name: "euIndikacio",
                label: "Támogatott indikáció",
                visibility: true,
                slot_name: "indikaciokFormat"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
            }
        ],
        bnoCodeRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                class: "btn btn-outline-success",
                event_payload: 'selectBnoRow'
            }
        ],
        headerBNOCodeFields: [
            {
                name: "kod",
                label: "Kód",
                filter: {
                    type: "simple",
                },
                visibility: true,
                slot_name: "rowSelect"
            },
            {
                name: "leiras",
                label: "Leírás",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
            }
        ]
    }
}
